<script lang="ts">
    import { Checkbox, Dot, FileDropzone, Label, RadioGroup, TextField } from "attractions";
    import Select from "svelte-select";
    import { PaperclipIcon } from 'svelte-feather-icons';
    import { toasts } from "svelte-toasts";
    import Import from "../../Models/Import";

    const filesExtensions = {
        'internal': '.json',
        'abs_pos': 'REST API'
    }
    const productsSources = [
        { label: window.location.host, value: 'internal' },
        { label: 'ABS POS', value: 'abs_pos' }
    ];
    const importModes = [
        { value: 'add', label: "Dodaj" },
        { value: 'update', label: "Zaktualizuj" },
        { value: 'replace', label: "Zastąp" }
    ];

    let choosenDestination: { label: string, value: string };
    let choosenImportMode: string;
    let defaultDiscount: number;
    let pickedFilesToImport: File[] = [];
    let restoreRemovedProducts: boolean;

    function warnAboutNoFileSelected() {
        toasts.warning(`Uwaga`, `Aby rozpocząć proces importowania produktów, musisz wskazać plik.`)
    }

    async function importWithFile() {
        const res = await Import.products(pickedFilesToImport[0], choosenImportMode);
    }

    async function syncWithABSPOS() {
        toasts.info(`ABS POS`, `Synchronizacja danych w toku...`, { duration: 0 });
        const res = await Import.ABS.products(defaultDiscount, restoreRemovedProducts);
        if (res) {
            toasts.clearAll();
            toasts.success(`ABS POS`, `Z powodzeniem zsynchronizowaliśmy informacje o ${res.details.count} produktach.`);
        }
    }
</script>

<section class="exportProducts">
    <Label style="margin-bottom: .35rem">Wybór platformy źródłowej</Label>
    <Select bind:value={choosenDestination} items={productsSources} placeholder="Wybierz..." isSearchable={false} />
    {#if choosenDestination && choosenDestination.value}
        <Label style="margin-top: .35rem">Format źródłowy</Label>
        <small class="fileExtension">{filesExtensions[choosenDestination.value]}</small>
        {#if filesExtensions[choosenDestination.value][0] == '.'}
            <Label style="margin-top: .35rem">Wybór pliku źródłowego</Label>
            <FileDropzone bind:files={pickedFilesToImport} accept={filesExtensions[choosenDestination.value]} max={1}>
                <PaperclipIcon size="16" />
                <span slot="empty-layer">Upuść lub wybierz plik z dysku</span>
            </FileDropzone>
            <Label style="margin-top: .35rem; margin-bottom: .35rem">Wybór trybu</Label>
            <RadioGroup bind:value={choosenImportMode} items={importModes} class="radioGroup" radioClass="radioLabel" labelClass="radioLabel" />
        {:else}
            <Label style="margin-top: .35rem">Domyślna wysokość zniżki</Label>
            <TextField bind:value={defaultDiscount} withItem type="number" min="0" max="100" style="margin-top: .35rem; max-width: 100px">
                <span class="item">%</span>
            </TextField>
            <small class="disclaimer">Dotyczy wyłącznie nowych produktów</small>
            <Label style="margin-top: .35rem">Dodatkowe ustawiena</Label>
            <div class="action">
                <Checkbox bind:checked={restoreRemovedProducts}>
                    <span class="label">Przywróć usunięte produkty</span>
                </Checkbox>
            </div>
        {/if}
        <Label style="margin-top: .35rem">Akcja</Label>
        {#if choosenDestination.value == 'internal'}
            <span>
                {#if pickedFilesToImport[0]}
                    <div on:click={importWithFile} class="action">
                        <Dot success /> 
                        <span class="label">Rozpocznij proces importowania</span>
                    </div>
                {:else}
                    <div on:click={warnAboutNoFileSelected} class="action">
                        <Dot attention />
                        <span class="label">Wybierz plik, aby rozpocząć</span>
                    </div>
                {/if}
            </span>
        {/if}
        {#if choosenDestination.value == 'abs_pos'}
            <span>
                <div on:click={syncWithABSPOS} class="action">
                    <Dot success /> 
                    <span class="label">Rozpocznij synchronizację</span>
                </div>
            </span>
        {/if}
    {/if}
</section>

<style lang="scss">
    .exportProducts {
        min-width: 300px;

        .action {
            display: flex;
            align-items: center;
            margin-top: .35rem;
            cursor: pointer;

            .label {
                margin-left: .2rem;
                font-size: .9rem;
            }
        }

        .fileExtension {
            display: block;
            color: gray;
            margin-top: .35rem;
            font-size: .85rem;
        }

        .disclaimer {
            display: block;
            color: gray;
            margin-top: .1rem;
            font-size: .65rem;
        }
    }
</style>